<div
  class="assign-cart-side-panel-container"
  [ngClass]="{ 'hide-create-activity': creatingActivity }"
  >
  <!-- Header -->
  <section class="assign-cart-header">
    <!-- Assign Icon with selected count -->
    <button
      class="assign-cart-icon-button"
      mat-fab
      aria-label="Assign Cart Button"
      [autofocus]="false"
      type="button"
      (click)="handleAddClick()"
      >
      <mat-icon
        [matBadge]="getCartItems(cartItems)"
        class="assign-cart-add-icon"
        >add</mat-icon
        >
      </button>

      <!-- Title -->
      <h4 class="assign-cart-title">Assign Cart</h4>

      <!-- Cancel button -->
      <button
        class="assign-cart-cancel"
        (click)="closeSidePanel()"
        mat-icon-button
        aria-label="Close Assign Cart"
        type="button"
        >
        <mat-icon class="assign-cart-close-icon">close</mat-icon>
      </button>
    </section>

    <!-- Pacing total -->
    @if (
      !creatingActivity &&
      ifMathProgram() &&
      this.cartItems &&
      this.cartItems.assets.length > 0
      ) {
      <section
        class="assign-cart-pacing-container"
        matTooltip="Total Pacing minutes. Custom assignments are not included in this time estimate."
        >
        <h4 class="pacing-title">{{ getTotalPacing(cartItems) }}</h4>
        @if (totalPacingWarning) {
          <div class="pacing-warning">
            Custom assignments are not included in this time estimate.
          </div>
        }
      </section>
    }

    <!-- Selected Assignables -->
    <section #assetScroller
      class="assign-cart-assignables"
      cdkDropList
      (cdkDropListDropped)="drop($event)"
      >
      @for (item of cartItems.assets; track item) {
        <div
          class="assign-cart-assignable"
          cdkDrag
          >
          <div class="assignable-details-container">
            <!-- Draggable Icon -->
            <mat-icon
              class="drag-icon"
              matTooltip="Drag to change activity order"
              >drag_indicator</mat-icon
              >
              <img
                [src]="getIcon(item)"
                matTooltip="{{ getToolTip(item) }}"
                class="icon-33-x-33"
                />
              <h4>{{ getAssignableName(item) }}</h4>
            </div>
            @if (
              !(assetInUse$ | async) || !editingLesson || editingActivity
              ) {
              <div
                class="remove-assignable-container"
                (click)="removeSelectedAssignable(item)"
                matTooltip="Remove from cart"
                >
                <mat-icon class="remove-icon">remove_circle</mat-icon>
              </div>
            }
          </div>
        }
        <!-- Select more Assignables -->
        @if (!creatingActivity) {
          <div
            class="assign-cart-select-more-container"
            >
            <h4 class="select-assignables-title">Activities</h4>
            <!-- No Activities Selected -->
            @if (showNoActivitiesSelectedForBundles()) {
              <div
                class="no-selected-cart-items"
                >
                <h4 class="no-selected-cart-items-title">
                  No Activities Selected!
                </h4>
                <p class="no-selected-cart-items-text">
                  At least 1 activity is required. Use the Add button to
                  select from the Content Library.
                </p>
              </div>
            }
            @if ((assetInUse$ | async) && editingLesson) {
              <p
                class="assetInUseWarn"
                >
                Activities cannot be removed from a bundle with outstanding
                assignments.
              </p>
            }
            <div class="select-assignables-button-container">
              @if (
                subjectId ||
                (!subjectId &&
                activeEditions &&
                activeEditions.length === 1)
                ) {
                <button
                  class="select-assignables-add-button"
                  type="button"
                  mat-button
                  color="primary"
                  (click)="handleAddClick()"
                  >
                  <mat-icon class="add-more-assignables-icon">add</mat-icon>
                  Add
                </button>
              }
              @if (cartItems && cartItems.assets.length > 0) {
                <button
                  class="select-assignables-add-button"
                  type="button"
                  mat-button
                  color="primary"
                  (click)="clearCartWarning()"
                  [disabled]="(assetInUse$ | async) && editingLesson"
                  >
                  <mat-icon class="add-more-assignables-icon">clear</mat-icon>
                  Clear All
                </button>
              }
              @if (
                !creatingLesson &&
                !editingLesson &&
                !creatingActivity &&
                !editingActivity
                ) {
                <button
                  class="select-assignables-create-button"
                  type="button"
                  mat-button
                  color="primary"
                  (click)="convertToActivityBuilder()"
                  >
                  <mat-icon class="add-more-assignables-icon"
                    >create</mat-icon
                    >
                    Create
                  </button>
                }
              </div>
            </div>
          }
        </section>

        <!-- Footer -->
        <section class="assign-cart-footer">
          <!-- Convert to Lesson (if applicable) -->
          @if (!creatingLesson && !creatingActivity) {
            <button
              type="button"
              mat-raised-button
              class="convert-to-lesson-button"
              [ngClass]="{ 'disabled-button': containsComposite }"
              [disabled]="containsComposite && cartItems?.assets.length"
              (click)="convertToLessonBuilder()"
              >
              {{ getConvertToLessonText() }}
            </button>
          }

          <!-- Create/Edit Lesson or Activity -->
          @if (creatingLesson || editingLesson) {
            <button
              [ngClass]="{ 'disabled-button': getCreateDisabled() }"
              [disabled]="getCreateDisabled()"
              (click)="create()"
              type="button"
              mat-raised-button
              class="create-button"
              >
              {{ getCreateEditButtonText() }}
            </button>
          }

          <!-- Go to Assign button (Assign, Create and Assign, or Create and Add) -->
          @if (
            subjectId ||
            (!subjectId && activeEditions && activeEditions.length === 1)
            ) {
            <button
              type="button"
              mat-raised-button
              class="assign-button"
              [ngClass]="{ 'disabled-button': getCreateDisabled() }"
              [disabled]="getCreateDisabled()"
              (click)="createAndAssign()"
              >
              {{ getAssignButtonText() }}
            </button>
          }
        </section>
      </div>
